import { Maestro_Usuarios } from './Maestro_Usuarios';
import { Maestro_Usuarios_IpsAutorizadas } from './Maestro_Usuarios_IpsAutorizadas';
import { Maestro_Usuarios_Roles_Canales } from './Maestro_Usuarios_Roles_Canales';

export class Maestro_Usuarios_Actualizacion {
    principal: Maestro_Usuarios;
    listaRoles: Maestro_Usuarios_Roles_Canales[];
    listaIpsAutorizadas: Maestro_Usuarios_IpsAutorizadas[];
    listaIpsAutorizadasEliminar: Maestro_Usuarios_IpsAutorizadas[];
}
